module.exports = __webpack_public_path__ + "static/media/solastalgia-thumb-6.6f5bb0e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solastalgia/solastalgia-thumb-6.jpg
// module id = 4444
// module chunks = 13